import { Pagination } from '../interfaces';

export const DEFAULT_PAGINATION: Pagination = {
  currentPage: 1,
  itemsPerPage: 30,
};
